// Tradein by salvarez

var App = {
  wizard: null,
  GetTradeinDevice: null,
  GetQuestions: null,
  GetAllBrand: null,
  wizardHtml: $('#wizard').html(),
  imeiStatus: false,
  questionsValuesArray: [],
  img: {
    apple: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/Recurso_5_1.5x.png?v=1676584515',
    samsung: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/Recurso_4_1.5x.png?v=1676584514',
    loader: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/loader.gif?v=1676584973',
    imgResultError: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/error.png?v=1691523496',
    imgResultOk: 'https://cdn.shopify.com/s/files/1/0418/4277/0081/files/ok.png?v=1691523496'
  },
  discountAmount: 0,
  data: { sbu: null, model: null, brand: null, imei: null, questionAmountYes: 0, questionAmountNo: 0, priceRuleId: null },
  url: {
    GetBrand: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/GetBrand',
    GetTradeinDevice: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/GetTradeinDevice/',
    GetQuestions: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/GetQuestions',
    GetCheckImei: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/GetCheckImei/',
    CreatePriceRule: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/CreatePriceRule',
    CreateDiscountCode: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/CreateDiscountCode',
    CreateHistoryLog: 'https://lmv95qyh48.execute-api.us-west-2.amazonaws.com/prod/CreateHistoryLog',
    addCart: '/cart/add.js',
    getCart: '/cart.json'
  },
  init: function () {
    App.events();
    $('.trade-in-trigger').fadeIn()
  },
  events: function() {
    $('body').on('click', '.trade-in-trigger',function() {
      $('#tradeinModal').modal({
          escapeClose: false,
          clickClose: false
      });
         
      const userEmail = SECOMAPP.customer.email;
      const userFirstName = SECOMAPP.customer.first_name;
      const userLastName = SECOMAPP.customer.last_name;
      
      const sku = $('span[data-product-sku]').text().trim();
      
      const objeto = {
        email: userEmail !== null ? `${userEmail}`: null,
        full_name: userEmail !== null ? `${userFirstName} ${userLastName}`: null,
        product_sku: sku,
        trade_model: null,
        id_action: 1
      };
      axios.post(App.url.CreateHistoryLog, objeto)
        .then(response => {
            console.log('Log registrado:', response.data);
        })
        .catch(error => {
            // Manejo de errores
            console.error('Error al registrar el log:', error);
        });
    });
    $('body').on('modal:before-open', function(event, modal) {
      App.setWizard();
      App.loadBrand();
      // activar button de imei 
      $(".btn-disabled").prop('disabled', false);
      
    });
    $('body').on('click', 'a.close-modal',function(event) {
         $('input[type=checkbox][name=trade-in-selector]').prop( "checked", false );
      // BOTON FINALIZAR //
      $('input[name="attributes[TradeIn]"]').val(JSON.stringify(App.data))
      name="attributes[TradeIn]"
    });
    $('body').on('click','.productBrands ',function(event) {
        var $input = $(this).find('input')        
        if ($('#tradeinModal').is(':visible')) {
            $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
        }
    });
    $('body').on('change','.tradeinQuestions input',function(event) {
        App.validaPaso3()
    });
  },
  loadBrand: function () {
     $('#content-loading-brand').html('<div class="loading"><img src="' + App.img.loader + '" /><br/>Un momento, por favor...</div>');
     $('ul.productBrands').empty()  
    try {
   $.get(App.url.GetBrand, function( data ) {
      App.GetAllBrand = data.data
     $.each(App.GetAllBrand, function(index, item) {
         switch(item.brand){
           case "Apple":
             brandImg = App.img.apple;
             break;
           case "Samsung":
             brandImg = App.img.samsung;
             break;
          default: 
             brandImg = App.img.apple;
             break;
         }

       $('ul.productBrands').append('<li id="' + index + '" onclick="App.loadSBU(`'+ item.brand + '`);"><label><input type="radio" name="brand" value="' + item.brand + '" data-brand="'+item.brand+'"><img src='+ brandImg + ' alt="'+ item.brand + '" title="'+ item.brand + '"/></label><h5>'+ item.brand + '</h5></li>');
     });
     $('#content-loading-brand').html('<div class="loading" hidden="true"></div>')
  })
      } catch (error) {
      console.log('error', error)
        $('#content-loading-brand').html('<div class="loading">Servicio no disponible, intentelo mas tarde</div>')
      }

  },
  loadSBU: function (brand) {
 $('#content-loading-model').html('<div class="loading"><img src="' + App.img.loader + '"/><br/>Un momento, por favor...</div>');
    $('ul.productModels').empty()
  try {
     $.get(App.url.GetTradeinDevice + brand, function( data ) {
      App.GetTradeinDevice = data.data;      
      $('ul.productModels').empty()
      $.each(App.GetTradeinDevice, function(index, item) {
        brand = item.brand;
      $('ul.productModels').append('<li id="' + index + '" onClick="App.selectedModel(`'+item.model+'`, `'+ item.discountAmount +'` );"> <label> <input type="radio" name="productname" value="' + item.discountAmount + '" for="'+ item.id +'" onClick="App.getModel();"> ' + item.model + '</label></li>');
    }); 
    $('#content-loading-model').html('<div class="loading" hidden="true"></div>')
    });
  } catch (error) {
     $('#content-loading-model').html('<div class="loading">Servicio no disponible, intentelo mas tarde</div>')
  }
   
  },
  loadQuestions: function() {
     $('#content-loading-questions').html('<div class="loading"><img src=' + App.loader + '/><br/>Un momento, por favor...</div>');
    $('.tradeinQuestions').empty()
    try {
      $.get(App.url.GetQuestions, function( data ) {
        App.GetQuestions = data.data
        $.each(App.GetQuestions, function(index, item) {
          $('.tradeinQuestions').append(
            //'<tr><td id="'+ item.id +'" style="width=30%" ><p class="overflow-visible">'+item.questions+'</p></td><td id="'+ item.id +'" style="width=15%" class="btnYesTd"><input class="question_'+ item.id +'" type="radio" name="question_'+ item.id +'" id="question_'+ item.id +'_yes" value="true"><label style="margin-top: -20px; margin-right: 10px">'+'<span>Si</span></label></td><td id="'+ item.id +'" style="width=15%" class="btnNoTd"><input class=question_'+ item.id +' type="radio" name="question_'+ item.id +'" id="question_'+ item.id +'_no" value="false"><label style="margin-top: -20px">'+'<span>No</span></label></td>'
            '<li id="'+ item.id +'" class="questionContainer"> <div class="row"><div class="question col-12 col-md-9">'+item.questions+'</div><div id="'+ item.id +'" class="switch-field col-12 col-md-3"> <input class="question_'+ item.id +' btnYesTd" type="radio" name="question_'+ item.id +'" id="question_'+ item.id +'_yes" value="true"> <label for="question_'+ item.id +'_yes">'+'<span>Si</span></label> <input class="question_ '+ item.id +' btnNoTd" type="radio" name="question_'+ item.id +'" id="question_'+ item.id +'_no" value="false"> <label for="question_'+ item.id +'_no">'+'<span>No</span></label> </div></div></li>'
            //'<li id="'+ item.id +'" class="questionContainer"> <div><p>'+item.questions+'</p></div><div id="'+ item.id +'" class="switch-field"> <label for="question_'+ item.id +'_yes" class="switch">'+'<span>Si</span> <input class="question_'+ item.id +' btnYesTd" type="radio" name="question_'+ item.id +'" id="question_'+ item.id +'_yes" value="true"> <span class="slider round"></span> </label> </div></li>'
          );
        });
        $('#content-loading-questions').html('<div class="loading" hidden="true"></div>')
        $('.questionsCount').append($('.tradeinQuestions li').length);
        
    }); 
    } catch (error) {
       $('#content-loading-questions').html('<div class="loading">Servicio no disponible, intentelo mas tarde</div>')
    }
   
  },
  getModel: function () {
        var radioProductName = jQuery('#formWizard').serializeArray().find(e => e.name === "productname").value;
        if(typeof(radioProductName) === 'string'){
          $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
        }else{
          $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "false");
        }
        if (typeof radioProductName !== 'undefined') {
          return true;
        } else {
          return false;
        }
  },
  checkImei: function () {
   $(".btn-disabled").prop('disabled', true);
    $('#content-loading-imei').html('<div class="loading"><img src="' + App.img.loader + '"/><br/>Un momento validando el IMEI</div>');
    $('ul.imeiResponse').empty()
    let = imeiValue = $("#imei").val();
    if (imeiValue != '') {
      $.get(App.url.GetCheckImei + imeiValue, function( data ) {
      $('ul.imeiResponse').empty()
    
      if (data.data == true) {
         $('ul.imeiResponse').append('<li><label class="info imeiSuccess">'+ data.message +'</label></li>'); 
      } else {
        $('ul.imeiResponse').append('<li><label class="info imeiError">'+ data.message +'</label></li>'); 
      }
      App.imeiStatus = data.data;
         $('#content-loading-imei').html('<div class="loading" hidden="true"></div>');
      $(".btn-disabled").prop('disabled', false);
      if ( App.imeiStatus === true ) {
      $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
      }else{
        $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "false");
      }
    });
   
      
    } else {
      $('ul.imeiResponse').append('<li><label class="info imeiError" style="color: #ad2323">Debes de ingresar un IMEI valido</label></li>'); 
    }
  },
  selectedModel: function(model, discountAmount) {
    App.discountAmount = discountAmount;

    $('p.modelSelected').empty()
    $('p.amountSelected').empty()

    $('p.modelSelected').append('Modelo: <strong class="trade-in-popup__summary-product-brand">' + model + '</strong>'); 
    $('p.amountSelected').append('<em class="trade-in-popup__summary-price color-amount-discount">-$'+ new Intl.NumberFormat().format(discountAmount) +'</em>');
  },
  setWizard: function() {    
    App.wizard = null
    $('#wizard').empty()
    $('#wizard').html(App.wizardHtml)
    var settings = {
      title: "Trade-in",
      labels: {
          finish: "Finalizar",
          next: "Continuar",
          previous: "Anterior"
      },
      onStepChanging: function(event, currentIndex, newIndex) {
        var enable = $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').attr("aria-disabled");
        if(enable === "true" && currentIndex < newIndex){
          return true
        }
        //Habilita volver atras
        if (newIndex < currentIndex) {
            return true;
        }
      },
      
      onStepChanged: function(event, newIndex ,currentIndex) {
        switch(newIndex) {
          case 0:
            var radioChanged = jQuery('#formWizard').serializeArray().find(e => e.name === "brand").value;
            if (typeof radioChanged !== 'undefined') 
              $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
            break;
          case 1:
            var radioChanged = jQuery('#formWizard').serializeArray().find(e => e.name === "productname").value;
            if(typeof radioChanged !== 'undefined')
              $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
            break;
          case 2:
            $('#imeiBtn').attr('disabled', 'disabled');
             $('#imei').on('keyup', function() {
                  let empty = false;
                  $('#imei').each(function() {
                    empty = $(this).val().length == 0;
                  });
                  if (empty)
                    $('#imeiBtn').attr('disabled', 'disabled');
                  else
                    $('#imeiBtn').attr('disabled', false);
              });
            if(App.imeiStatus)
              //$('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
            break;
          case 3:
            if(currentIndex === 3){
              $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a[href='#']").hide();
            }
            App.validaPaso3();
            break;
          case 4:
            var values = {};
            console.log("$('#formWizard').serializeArray() =>", $('#formWizard').serializeArray());
            $.each($('#formWizard').serializeArray(), function(i, field) {
              values[field.name] = field.value;
              console.log("values[field.name] : ", values[field.name]);
              if(field.name === "brand"){
                var theBrand = field.value;
                $('p.marcaseleccionada').empty()
                $('p.marcaseleccionada').append('Marca: <strong class="trade-in-popup__summary-product-brand">' + theBrand + '</strong>'); 
              }
              $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a").hide();
              if(field.value === 'false'){
                $('h2.titleFinal').text('Lo sentimos, no es posible entregar un descuento.');
                $('em.trade-in-popup__summary-price.color-amount-discount').text('$0');
                $(".imgResult").attr("src",App.img.imgResultError);
                $(".terms").hide();
                $(".information").hide();
                $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a").attr("href", "#");
                return false;
              }else {
                $('h2.titleFinal').text('¡Todo Listo! Confirma tu precio final para terminar');
                $('em.trade-in-popup__summary-price.color-amount-discount').text('$' + new Intl.NumberFormat().format(App.discountAmount));
                $(".imgResult").attr("src",App.img.imgResultOk);
                $(".terms").show();
                $(".information").show();
                $('#wizard > div.actions.clearfix > ul > li:nth-child(3)').removeClass("disabled").attr("aria-disabled", "true");
                $('input[type=checkbox][name=trade-chk]').on('change',function() {
                  if ($(this).is(':checked')) {
                      $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a[href='#finish']").show();
                      $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a").attr("href", "#finish");
                  }
                });
                if($('input[type=checkbox][name=trade-chk]').is(":checked")){
                  $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a[href='#finish']").show();
                  $("#wizard > div.actions.clearfix > ul > li:nth-child(3) a").attr("href", "#finish");
                }
              }
            });
              break;
          default:
            // code block
        }
        
      },
      onFinished: function (event, currentIndex, priorIndex, newIndex) {
        $("#wizard").find('a[href="#finish"]').attr("href", '#finish-disabled');
        var loaderElement = $('<img src="https://cdn.shopify.com/s/files/1/0418/4277/0081/files/loader.gif?v=1676584973" style="width: 30px; padding-left: 10px"/>');
        $("#wizard").find('a[href="#finish-disabled"]').append(loaderElement);
        let produdctId;
        $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
        var booleanValues = []
        $.each($('#formWizard').serializeArray(), function(i, field) {
            booleanValues[field.name] = field.value;
          });
        const userEmail = SECOMAPP.customer.email;
        const userFirstName = SECOMAPP.customer.first_name;
        const userLastName = SECOMAPP.customer.last_name;
        const tradeModel = $('p.modelSelected').text().replace('Modelo: ', '');
        
        const sku = $('span[data-product-sku]').text().trim();
        
        const objeto = {
          email: userEmail !== null ? `${userEmail}`: null,
          full_name: userEmail !== null ? `${userFirstName} ${userLastName}`: null,
          product_sku: sku,
          trade_model: tradeModel,
          id_action: 2
        };
        axios.post(App.url.CreateHistoryLog, objeto)
          .then(response => {
              console.log('Log registrado:', response.data);
          })
          .catch(error => {
              // Manejo de errores
              console.error('Error al registrar el log:', error);
          });
        if(Object.values(booleanValues).includes("false")){
          console.log("HAY UN VALOR EN 'NO' ... ");
          if($("input[name=id]").length === 1){
            produdctId = $("input[name=id]").val()
            console.log("Producto NO tiene variantes, ID:", produdctId)
          } else {
            produdctId= $("select[name=id] option:selected").val()
            console.log("Producto tiene variantes, ID:", produdctId)
          }
          location.href = "/cart/"+ produdctId +":"+$("#product-quantity-select").val()+"?discount=";
        }else {
          console.log("TODOS LOS VALORES SON 'SI' ... ");
          function makeid(length) {
              let result = '';
              const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
              const charactersLength = characters.length;
              let counter = 0;
              while (counter < length) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
              }
              return result;
          };
          localStorage.removeItem('discountCode');
          localStorage.removeItem('variantId');
          localStorage.removeItem('discountValue');
          localStorage.removeItem('tradeinDeviceId');
          localStorage.removeItem('tradeinImei');
          var deviceId= $('input[name=productname]:checked', '#formWizard').attr("for");
          var tradeinImei= $('#imei', '#formWizard').val();
          var priceRuleAmount= $('input[name=productname]:checked', '#formWizard').val();
          var variantIdProd = $(".product-form--alt form").attr("id").replace("product_form_", "");
          var ruleTitle = 'TradeIn-' + makeid(5);
          var ruleStorage = localStorage.getItem("ruleId") !== null ? localStorage.getItem("ruleId") : "";
          const article = { priceRuleTitle: ruleTitle, value: priceRuleAmount, productId: variantIdProd, ruleID: ruleStorage };
          if($("input[name=id]").length === 1){
            produdctId = $("input[name=id]").val();
            console.log("Producto NO tiene variantes, ID:", produdctId);
          } else {
            produdctId= $("select[name=id] option:selected").val();
            console.log("Producto tiene variantes, ID:", produdctId);
          }
          axios.post(App.url.CreatePriceRule, article)
          .then((response) => {
            localStorage.removeItem('ruleId');
            console.log("response tradein: ", response.data.data.price_rule.id)
            var rule = { shopify_rule_id: response.data.data.price_rule.id };
            axios.post(App.url.CreateDiscountCode, rule)
            .then((response) => {
              axios.post(App.url.addCart, {
                items: [
                  {
                    quantity: $("#product-quantity-select").val(),
                    id: produdctId
                  }
                ]
              }).then((res) => {
              let cartTokenId = "";
              $.get(App.url.getCart)
                .then(cartJsonRes => {
                  localStorage.setItem('ruleId', rule.shopify_rule_id);
                  localStorage.setItem('discountCode', response.data.data.discount_code.code);
                  localStorage.setItem('variantId', produdctId);
                  localStorage.setItem('discountValue', App.discountAmount);
                  localStorage.setItem('tradeinDeviceId', deviceId);
                  localStorage.setItem('tradeinImei', tradeinImei);
              })
              .catch((error) => {
                console.error('Error /cart.json:', error);
              });
                
                location.href = "/cart/";
                //location.href = "/cart/"+ $("input[name=id]").val() +":"+$("#product-quantity-select").val()+"?discount="+response.data.data.discount_code.code;
                });
            })
            .catch(error => {
              console.log("error : ", error);
            })
           })
          .catch(error => {
            console.log("error : ", error);
          });
        }
      },
    };
    App.wizard = $("#wizard").steps(settings);
    App.loadQuestions();
  },
  validaPaso3: function(){
    var count = 0
    $('.tradeinQuestions input.btnYesTd').each(function(e){
        if($(this).is(':checked'))
          count++;
    })
    $('.tradeinQuestions input.btnNoTd').each(function(e){
        if($(this).is(':checked'))
          count++;
    })
    if(count === 10)
      $('#wizard > div.actions.clearfix > ul > li:nth-child(2)').removeClass("disabled").attr("aria-disabled", "true");
  }
}
$(document).ready(App.init)
